import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
type CTAButtonProps = {
  label: string;
  subline?: string;
  id?: string;
};
export function CTAButton({
  label,
  subline,
  id
}: CTAButtonProps) {
  return <div id={id} className="flex w-full flex-col items-center gap-3" data-id="element-27" data-mp="2fz20qldwwuuz">
      <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
      value: 27,
      currency: 'USD'
    })} className="group flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-brick-600 px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(207,32,39,0.6)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-brick-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brick-600 active:translate-y-[1px] sm:text-lg sm:px-8 sm:py-5" data-id="element-28" data-mp="2g1xz2ato9ljy">
        <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-white/90" aria-hidden="true" data-id="element-29" data-mp="199ob65sfepo0" />
        <span className="text-balance" data-id="element-30" data-mp="1d9q6zybhcovd">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="1dcks7s2bidpu" />
      </a>
      {subline ? <p className="max-w-sm text-center text-[13px] font-medium leading-relaxed text-navy-500 sm:text-sm" data-id="element-32" data-mp="1n6l5wibo0ra6">
          {subline}
        </p> : null}
    </div>;
}